import { useQuery } from "@tanstack/react-query";

import { api } from "./ApiClient";

import { AuthHelper } from "../helpers/auth.helper";

import { IMBTSAnalysisListItem } from "../types/services.interfaces/dashboard";

export const useGetDashboardMBTSAnalyses = () => {
    AuthHelper.presetPrivateRequest(api);

    const queryFn = async (): Promise<IMBTSAnalysisListItem[]> => {
        const res = await api.get('/dashboard/analyses/mbts');
        return res.data;
    };

    return useQuery({
        queryKey: ['dashboard-mbts-analyses'],
        queryFn,
        retry: false,
        enabled: AuthHelper.isAuthTokenValid().result,
    });
};
